// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".home-container .alert-text[data-v-6d002780] {\n  color: #e9a021;\n  cursor: default;\n}\n.home-container .hx-form-container .add-btn[data-v-6d002780] {\n  margin-left: 10px;\n}\n.home-container .hx-form-container .add-btn span[data-v-6d002780] {\n  text-decoration: underline;\n}\n", ""]);
// Exports
module.exports = exports;
